module.exports = __webpack_public_path__ + "static/media/do-not-enter.530fe925.svg";